import React from 'react'
import { useDispatch } from 'react-redux'
import { Form, Grid } from 'semantic-ui-react'
import InputField from '../../../commonComponents/formComponents/inputField'
import { useSelector } from 'react-redux'

const ItemHeader = ({ translate, updateItemHeaderData}) => {
    const { packages = '', grossWeight = '',netWeight = '',totalValue = '' } = useSelector(state => state?.InvoicesReducer?.invoiceHeader)

    const dispatch = useDispatch()

    return (
        <Form.Group className='float-container'>
            <Grid>
                <Grid.Row>
                    <Grid.Column width='4' className='divFormFeild border-bottom b-rw-0 b-blr-5 b-tlr-5'>
                        <InputField
                            isLabel={false}
                            id={`totalShipmentPackages`}
                            type='number'
                            label={translate('PACKAGES', { ns: ['default', 'lineItem'] })}
                            className={'field-bg'}
                            value={parseFloat(packages)}
                            clearInput={false}
                            disabled={true}
                            onChange={(value) => {
                                dispatch(updateItemHeaderData({ 'packages': value }))
                            }}
                            // onBlur={(value) => {
                            //     dispatch(saveItemHeaderData('packages'))
                            // }}
                        />
                    </Grid.Column>
                    <Grid.Column width='4' className='divFormFeild border-bottom b-rw-0 '>
                        <InputField
                            isLabel={false}
                            id={`shipmentValue`}
                            type='number'
                            label={translate('GROSS_WEIGHT', { ns: ['default', 'lineItem'] })}
                            className={'field-bg'}
                            value={grossWeight}
                            clearInput={false}
                            disabled={true}
                            onChange={(value) => {
                                dispatch(updateItemHeaderData({ 'grossWeight': value }))
                            }}
                            // onBlur={(value) => {
                            //     dispatch(saveItemHeaderData('grossWeight'))
                            // }}
                        />
                    </Grid.Column>
                    <Grid.Column width='4' className='divFormFeild border-bottom b-rw-0 '>
                        <InputField
                            isLabel={false}
                            id={`netWeight`}
                            type='number'
                            label={translate('NET_WEIGHT', { ns: ['default', 'lineItem'] })}
                            className={'field-bg'}
                            value={netWeight}
                            clearInput={false}
                            disabled={true}
                            onChange={(value) => {
                                dispatch(updateItemHeaderData({ 'netWeight': value }))
                            }}
                            // onBlur={(value) => {
                            //     dispatch(saveItemHeaderData('netWeight'))
                            // }}
                        />
                    </Grid.Column>

                    <Grid.Column width='4' className='divFormFeild border-bottom  b-brr-5 b-trr-5'>
                        <InputField
                            isLabel={false}
                            id={`totalValue`}
                            type='number'
                            label={translate('TOTAL_INV_VALUE_EUR', { ns: ['default', 'lineItem'] })}
                            value={totalValue}
                            className={'field-bg'}
                            clearInput={false}
                            disabled={true}
                            onChange={(value) => {
                                dispatch(updateItemHeaderData({ 'totalValue': value }))
                            }}
                            // onBlur={(value) => {
                            //     dispatch(saveItemHeaderData('totalValue'))
                            // }}
                        />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Form.Group>
    )
}

export default ItemHeader